/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ type, children, isClickable = false, icon = 'cancel', onClick }) => (
  <div
    className={`alert  ${
      isClickable
        ? `alert-action cursor-pointer alert-${type}`
        : ` alert-${type} alert-${type}-no-hover `
    }`}
    role={isClickable ? 'button' : 'banner'}
    onClick={onClick}
    onKeyDown={onClick}
    tabIndex={-1}>
    <i className={`icon icon-${icon}-icon`} />
    <span className="content">{children}</span>
    {isClickable && (
      <i
        className="icon icon-arrow-next-navigation ms-auto"
        style={{ width: '1rem', height: '1rem' }}
      />
    )}
  </div>
);

Alert.propTypes = {
  type: PropTypes.oneOf(['danger', 'info', 'warning', 'success']).isRequired,
  icon: PropTypes.oneOf(['cancel', 'info', 'attention', 'check']).isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  isClickable: PropTypes.bool,
  onClick: PropTypes.func,
};

Alert.defaultProps = {
  onClick: null,
  isClickable: null,
};
export default Alert;
